import { BTN_SAVE_AND_LEAVE, BTN_SECONDARY, BTN_DESTRUCTIVE_FILLED, BORDER_DEFAULT, TEXT_HEADING, BG_SURFACE, FONT_BODY, FONT_BUTTON } from '../../theme';

export default function ConfirmDialog({ open, message, onConfirm, onCancel, confirmLabel, cancelLabel, secondaryAction, confirmColor, content = null }) {
  if (!open) return null;

  const primaryStyle = confirmColor || BTN_DESTRUCTIVE_FILLED;
  const secondaryStyle = (secondaryAction && secondaryAction.color) || BTN_SAVE_AND_LEAVE;

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(15, 34, 53, 0.45)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: BG_SURFACE,
          border: `1px solid ${BORDER_DEFAULT}`,
          borderRadius: 10,
          padding: '1.75rem 2rem',
          maxWidth: 420,
          width: '90%',
        }}
      >
        {content !== null && content !== undefined ? content : (
          <p style={{
            ...FONT_BODY,
            color: TEXT_HEADING,
            margin: '0 0 1.5rem',
            lineHeight: 1.55,
            whiteSpace: 'pre-wrap',
          }}>
            {message}
          </p>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button
            type="button"
            onClick={onCancel}
            style={{
              ...BTN_SECONDARY,
              ...FONT_BUTTON,
              fontWeight: 400,
              borderRadius: 8,
              padding: '0.5rem 1.1rem',
              cursor: 'pointer',
            }}
          >
            {cancelLabel || 'Cancel'}
          </button>
          {secondaryAction && (
            <button
              type="button"
              onClick={secondaryAction.onClick}
              style={{
                ...secondaryStyle,
                ...FONT_BUTTON,
                fontWeight: 700,
                border: secondaryStyle.border || 'none',
                borderRadius: 8,
                padding: '0.5rem 1.1rem',
                cursor: 'pointer',
              }}
            >
              {secondaryAction.label}
            </button>
          )}
          <button
            type="button"
            onClick={onConfirm}
            style={{
              ...primaryStyle,
              ...FONT_BUTTON,
              fontWeight: 700,
              border: primaryStyle.border || 'none',
              borderRadius: 8,
              padding: '0.5rem 1.1rem',
              cursor: 'pointer',
            }}
          >
            {confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}
